import { Input } from '@/shadcn/input';

import { isLockedWidget } from '@/components/forms/utils/links';
import { useDynamicProps } from '@/hooks/useDynamicProps';
import { usePropsSynchronization } from '@/hooks/usePropsSynchronization';
import { TestId } from '@/types/testId';
import useInput from '@/utils/hooks/useInput';
import type { WidgetWriterProps } from '../widget.type';

type Props = WidgetWriterProps & {
  inputType?: React.HTMLInputTypeAttribute;
};

export const TextInput = (rjsfProps: Props) => {
  const props = useDynamicProps(rjsfProps);
  const isLocked = isLockedWidget(props.id, props.formContext?.links);

  const [textInputValue, updateTextInputValue] = useInput(
    props.value,
    (value: string) => {
      props.onChange(value);
    },
    200
  );

  usePropsSynchronization(props, rjsfProps, v => {
    const fakeEvent = {
      target: {
        value: v
      }
    } as React.ChangeEvent<HTMLInputElement>;
    updateTextInputValue(fakeEvent);
  });

  const inputType = props.inputType || props.options.inputType || 'text';

  return (
    <Input
      aria-label={props.label ?? ''}
      className={props.className}
      data-cy={`text-${props.name}`}
      data-testid={TestId.FormWriter.TextInput}
      disabled={props.disabled || isLocked}
      id={props.id}
      invalid={props.invalid}
      onChange={updateTextInputValue}
      placeholder={props.placeholder || 'Aa'}
      type={inputType}
      value={textInputValue}
    />
  );
};
